import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type CreateBatchReferralResponse = {
  __typename?: 'CreateBatchReferralResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateBatchReferralsInput = {
  clinicianId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  referrals: Array<CreateReferralInput>;
};

export type CreateReferralInput = {
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type GetOrgStatsInput = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetOrgStatsResponse = {
  __typename?: 'GetOrgStatsResponse';
  accountCreatedCount: Scalars['Int']['output'];
  cancelledCount: Scalars['Int']['output'];
  completionRatePercentage?: Maybe<Scalars['Float']['output']>;
  expiredCount: Scalars['Int']['output'];
  inviteCount: Scalars['Int']['output'];
  reportsCompletedCount: Scalars['Int']['output'];
};

export type GetReferralsFilters = {
  fromCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  fromReferralDate?: InputMaybe<Scalars['Date']['input']>;
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  showCompletedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toCompletedDate?: InputMaybe<Scalars['Date']['input']>;
  toReferralDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetReferralsInput = {
  filters?: InputMaybe<GetReferralsFilters>;
  pagedQuery?: InputMaybe<PagedQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortParams>;
};

export type GetReferralsResponse = {
  __typename?: 'GetReferralsResponse';
  referrals: Array<Referral>;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createBatchReferrals: CreateBatchReferralResponse;
};


export type MutationCreateBatchReferralsArgs = {
  batchReferralsInput: CreateBatchReferralsInput;
};

export type OrganisationServicesResponse = {
  __typename?: 'OrganisationServicesResponse';
  services: Array<Service>;
};

export type PagedQuery = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type Patient = {
  __typename?: 'Patient';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  piSystemId: PiSystemId;
};

export type PiSystemId = {
  __typename?: 'PiSystemId';
  id: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getOrgStats: GetOrgStatsResponse;
  getOrganisationServices: OrganisationServicesResponse;
  getReferrals: GetReferralsResponse;
};


export type QueryGetOrgStatsArgs = {
  input: GetOrgStatsInput;
};


export type QueryGetReferralsArgs = {
  input: GetReferralsInput;
};

export type Referral = {
  __typename?: 'Referral';
  clinicianId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  reportAvailable?: Maybe<Scalars['Boolean']['output']>;
  service: Service;
  sourceId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ReferralSortField {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  PiSystemId = 'piSystemId',
  Status = 'status'
}

export type Service = {
  __typename?: 'Service';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortParams = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ReferralSortField>;
};

export type GetReferralsQueryVariables = Exact<{
  input: GetReferralsInput;
}>;


export type GetReferralsQuery = { __typename?: 'Query', getReferrals: { __typename?: 'GetReferralsResponse', totalCount: number, referrals: Array<{ __typename?: 'Referral', createdAt: any, completedAt?: any | null, status: string, id: string, reportAvailable?: boolean | null, service: { __typename?: 'Service', code: string, description: string }, patient: { __typename?: 'Patient', givenName: string, familyName: string, piSystemId: { __typename?: 'PiSystemId', id: string, system: string } } }> } };

export type GetOrgStatsQueryVariables = Exact<{
  input: GetOrgStatsInput;
}>;


export type GetOrgStatsQuery = { __typename?: 'Query', getOrgStats: { __typename?: 'GetOrgStatsResponse', inviteCount: number, completionRatePercentage?: number | null, cancelledCount: number, expiredCount: number, accountCreatedCount: number, reportsCompletedCount: number } };

export type GetOrganisationServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationServicesQuery = { __typename?: 'Query', getOrganisationServices: { __typename?: 'OrganisationServicesResponse', services: Array<{ __typename?: 'Service', code: string, description: string }> } };


export const GetReferralsDocument = gql`
    query GetReferrals($input: GetReferralsInput!) {
  getReferrals(input: $input) {
    totalCount
    referrals {
      createdAt
      completedAt
      service {
        code
        description
      }
      status
      id
      patient {
        piSystemId {
          id
          system
        }
        givenName
        familyName
      }
      reportAvailable
    }
  }
}
    `;

export function useGetReferralsQuery(options: Omit<Urql.UseQueryArgs<GetReferralsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReferralsQuery, GetReferralsQueryVariables>({ query: GetReferralsDocument, ...options });
};
export const GetOrgStatsDocument = gql`
    query GetOrgStats($input: GetOrgStatsInput!) {
  getOrgStats(input: $input) {
    inviteCount
    completionRatePercentage
    cancelledCount
    expiredCount
    accountCreatedCount
    reportsCompletedCount
  }
}
    `;

export function useGetOrgStatsQuery(options: Omit<Urql.UseQueryArgs<GetOrgStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrgStatsQuery, GetOrgStatsQueryVariables>({ query: GetOrgStatsDocument, ...options });
};
export const GetOrganisationServicesDocument = gql`
    query GetOrganisationServices {
  getOrganisationServices {
    services {
      code
      description
    }
  }
}
    `;

export function useGetOrganisationServicesQuery(options?: Omit<Urql.UseQueryArgs<GetOrganisationServicesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationServicesQuery, GetOrganisationServicesQueryVariables>({ query: GetOrganisationServicesDocument, ...options });
};